export default {
    closeTheModal: {
        type:Function,
        required: true
    },
    overlayContent: {
        type: String,
        required: false
    },
    dialogElement: {
        type: Element,
        required: true
    },
    guid: {
        type: String,
        required: false,
        default: ''
    }
}